<template>
  <div>
    <OTextField
      class="pa-6 w-300"
      placeholder="Filtrar..."
      v-model="keywords"
      clearable
    />
    <ODataGrid class="dense-table" :data="gridData" />
  </div>
</template>

<script>
import ODataGrid from 'oderon-vue/cpts/ODataGrid.vue'
import { preProcessSpec } from 'oderon-commons/src/tables'
import grid from 'oderon-commons/src/grid'
import utils from 'oderon-commons/src/utils.js'
import fmt from 'oderon-commons/src/formatters'

const spec = preProcessSpec({
  defaultSortable: true,
  columns: [
    { t: 'id', d: 'id' },
    { t: 'name', d: 'name' },
    { t: 'ssid', d: 'ssid' },
    { t: 'pass', d: 'pass' },
    { t: 'Updated at|', d: 'updatedAt', f: fmt.brDateTime, w: 180 }
  ]
})

export default {
  components: {
    ODataGrid
  },
  props: {
    networks: { required: true }
  },
  data() {
    return {
      keywords: null
    }
  },
  computed: {
    filteredRows() {
      let result = this.networks.filter((x) =>
        utils.matchAnyLike(this.keywords, x.name, x.ssid)
      )

      return result
    },
    gridData() {
      return grid.generateWebGrid({
        rows: this.filteredRows,
        spec
      })
    }
  }
}
</script>

<style></style>
